import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['orgRow', 'floorRow'];
  static values = { expanded: { type: Array, default: [] } };
  static classes = ['hidden'];

  connect() {
    const fromUrl = (
      new URLSearchParams(window.location.search).get('expanded') || ''
    )
      .split(',')
      .filter(Boolean);

    if (fromUrl.length) {
      this.expandedValue = fromUrl;
    } else {
      this.applyExpanded();
    }
  }

  toggle({ params: { org }, target }) {
    if (target.closest('a, input')) return;

    const id = String(org);
    this.expandedValue = this.expandedValue.includes(id)
      ? this.expandedValue.filter((existing) => existing !== id)
      : [...this.expandedValue, id];
  }

  // Stimulus value-change callback: single source of truth for syncing
  // expanded state to the DOM, the URL, and the period header.
  expandedValueChanged() {
    this.applyExpanded();

    const serialized = this.expandedValue.join(',');
    const url = new URL(window.location);
    if (serialized) url.searchParams.set('expanded', serialized);
    else url.searchParams.delete('expanded');
    history.replaceState(null, '', url);

    this.dispatch('changed', { detail: { expanded: serialized } });
  }

  applyExpanded() {
    const ids = this.expandedValue.map(String);

    this.orgRowTargets.forEach((row) => {
      row.setAttribute(
        'aria-expanded',
        String(ids.includes(String(row.dataset.floorToggleOrgParam)))
      );
    });

    this.floorRowTargets.forEach((row) => {
      row.classList.toggle(
        this.hiddenClass,
        !ids.includes(String(row.dataset.floorToggleOrgParam))
      );
    });
  }
}
